module.exports = __webpack_public_path__ + "img/velvet.be5030ca.webp";